import theme from '../../../theme';

const styles = {
  tabContainer: {
    display: 'flex',
    paddingRight: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid',
    borderBottomColor: 'gray.lightBorder',
    background: '#F7F7F7',
    alignItems: 'flex-end',
    marginBottom:'8px'
  },
  tabs: {
    paddingLeft: 1,
  },
  activeTab: {
    fontFamily: 'Nunito Sans',
    fontWeight: '600',
    fontSize: '16px',
    border: '0.5px solid',
    borderColor: 'gray.light',
    borderRadius: '10px 10px 0px 0px',
    boxShadow: 'none',
    color: 'gray.main',
    textTransform: 'capitalize'
  },
  inactiveTab: {
    borderRadius: '10px 10px 0px 0px',
    textTransform: 'capitalize',
    color: 'white.main',
    fontFamily: 'Nunito Sans',
    fontWeight: '600',
    fontSize: '16px',
    boxShadow: 'none',
    background: 'gradient.main'
  },
};

export default styles;